import { Box, Button, CircularProgress, Paper, TextField, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { accountLoginRequest } from 'redux/reducers/auth/reducer';
import { getAccountLoginLoader } from 'redux/reducers/auth/selectors';
import { IS_NEMAN } from '../../services/constants/env';

export const LoginForm: FC = () => {
	const dispatch = useDispatch();
	const isLoading = useSelector(getAccountLoginLoader);

	const [login, setLogin] = useState<string>('');
	const [password, setPassword] = useState<string>('');

	const isFormValid = login.length >= 4 && password.length >= 4;

	const handleLoginSubmit = () => {
		// if (!isFormValid || isLoading) return;
		dispatch(accountLoginRequest({ login, password }));
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter') handleLoginSubmit();
	};

	return (
		<>
			<Helmet>
				<title>Login page</title>
				<link rel="icon" href={`${IS_NEMAN ? '/favicon-neman.ico' : '/favicon.ico'}`} />
			</Helmet>

			<Box
				onKeyDown={handleKeyDown}
				sx={{
					display: 'flex',
					flexWrap: 'wrap',
					justifyContent: 'center',
					backgroundColor: '#aaaaaa',
					height: '100vh',

					'& > :not(style)': {
						m: 1,
						width: '300px',
						height: '380px',
						marginTop: '20vh',
						padding: '20px',
					},
				}}
			>
				<Paper>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<Box style={{ textAlign: 'center', width: '100%' }}>
							{/* <AtlasChatLogo /> */}
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									gap: 0.5,
									justifyContent: 'center',
									width: '100%',
								}}
							>
								<Typography
									sx={{
										fontSize: '1.6rem',
										fontWeight: 900,
										color: '#0f172a',
									}}
								>
									Neman
								</Typography>
								<Typography
									component="span"
									sx={{ color: '#3399ff', fontSize: '1.6rem', fontWeight: 900 }}
								>
									IOSS
								</Typography>
							</Box>

							{/* <Typography
							variant="h6"
							noWrap
							component="div"
							sx={{
								mt: '-10px',
								fontFamily: 'monospace',
								fontWeight: 700,
								letterSpacing: '.3rem',
								color: '#66cbff',
								textDecoration: 'none',
								fontSize: 22,
							}}
						>
							admin panel
						</Typography> */}
						</Box>
					</div>

					<Typography
						sx={{
							fontSize: '1.4rem',
							fontWeight: 900,
							color: '#0f172a',
							textAlign: 'center',
							marginTop: '20px',
							marginBottom: '15px',
						}}
					>
						Sign in
					</Typography>
					<TextField
						label="login"
						type="text"
						variant="outlined"
						sx={{ marginTop: '20px' }}
						value={login}
						onChange={(e) => setLogin(e.target.value)}
						fullWidth
						// error={!isEmailValid()}
						error={login.length > 0 && login.length < 4}
					/>
					<TextField
						label="password"
						type="password"
						variant="outlined"
						sx={{ marginTop: '20px' }}
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						fullWidth
						error={password.length > 0 && password.length < 4}
					/>
					<Button
						size="large"
						sx={{ marginTop: '50px', width: '100%', backgroundColor: '#0f172a' }}
						variant="contained"
						autoFocus
						onClick={handleLoginSubmit}
						// disabled={!isFormValid || isLoading}
					>
						{/* {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Sign in'} */}
						Sign in
					</Button>
				</Paper>
			</Box>
		</>
	);
};
